import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';
import { Ref } from 'vue';

export function useDanmarksStatistikData(danmarks_statistik: Ref<boolean>) {
    const { data: danmarksStatistikData } = useQuery({
        queryKey: ['danmarks-statistik-data'],
        queryFn: async () => {
            const { data } = await axios.get(route('v2.salary.employees.danmarks-statistik-data'));
            return data;
        },
        placeholderData: [],
        enabled: danmarks_statistik,
    });

    return {
        danmarksStatistikData,
    };
}
